import * as React from 'react';

const Fi16 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 16 16", width: 16, height: 16, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#F1F2F1", d: "M1 5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2z" }), /* @__PURE__ */ React.createElement("path", { fill: "#002F6C", d: "M5 9v4h2V9h8V7H7V3H5v4H1v2z" }));
Fi16.Size = 16;
Fi16.Title = "Fi";

export { Fi16 as default };
